export default [
  {
    path: '/admin/lucky-draw-available-items',
    name: 'lucky-draw-available-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/lucky-draw/lucky-draw-available-item/index.vue')
  }
]